import React from "react";
import { Toast } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";

/**
 * Success / error confirmation toast.
 * @param {"top-end"|"center"} placement — top-right (default) or centered on the page.
 */
export default function ConfirmationToast({
  show,
  variant = "success",
  message,
  onClose,
  delay = 4000,
  successTitle = "Success",
  errorTitle = "Error",
  placement = "top-end"
}) {
  const isSuccess = variant === "success";

  const positionClass =
    placement === "center"
      ? "position-fixed top-50 start-50 translate-middle p-3"
      : "position-fixed top-0 end-0 p-3";

  return (
    <div
      className={positionClass}
      style={{ zIndex: 1100, maxWidth: "min(420px, calc(100vw - 1.5rem))", pointerEvents: "none" }}
      aria-live="polite"
    >
      <Toast
        show={show}
        onClose={onClose}
        className={`${isSuccess ? "bg-success text-white" : "bg-danger text-white"} shadow`}
        style={{ pointerEvents: "auto" }}
        autohide
        delay={delay}
      >
        <Toast.Header className={isSuccess ? "text-success" : "text-danger"} closeButton>
          <FontAwesomeIcon icon={isSuccess ? faCheckCircle : faExclamationCircle} className="me-2" />
          <strong className="me-auto">{isSuccess ? successTitle : errorTitle}</strong>
        </Toast.Header>
        <Toast.Body>{message}</Toast.Body>
      </Toast>
    </div>
  );
}
